import { Grid } from '@mui/material';

import { useEffect } from 'react';
import { PlanContextProvider } from './context';
import { useManagePlanQuery } from './hooks/useManagePlanQuery';
import { PlannerPlansCalendar } from './plans-calendar';
import { PlannerPlansDay } from './plans-day';

export const PlannerPlans = () => {
  return (
    <PlanContextProvider>
      <PlannerPlansContent />
    </PlanContextProvider>
  );
};

export const PlannerPlansContent = () => {
  const { clearPlanQueries } = useManagePlanQuery();

  useEffect(() => {
    return () => {
      // If you don't set a timeout, the query will be invalidated before it changes of context, and it will fetch it again.
      setTimeout(() => {
        clearPlanQueries();
      }, 500);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      style={{ width: `100%`, height: `100%`, padding: `24px`, columnGap: `24px` }}
    >
      <Grid item xs={9}>
        <PlannerPlansCalendar />
      </Grid>

      <Grid item xs={3}>
        <PlannerPlansDay />
      </Grid>
    </Grid>
  );
};
